{
    "name": "frontend",
    "version": "1.13.2",
    "scripts": {
        "ng": "ng",
        "local": "ng serve --configuration=local",
        "start": "ng serve",
        "build": "ng build --configuration=production --localize",
        "build:dev": "ng build --configuration=development --localize",
        "build:local": "ng build --configuration=local --localize",
        "lang": "ng extract-i18n --output-path src/locale --format=json",
        "watch": "ng build --watch --configuration=local",
        "watch:dev": "ng build --watch --configuration=development",
        "test": "ng test",
        "lint:styles": "stylelint \"src/**/*.scss\"",
        "lint:styles:fix": "stylelint \"src/**/*.scss\" --fix",
        "prepare": "husky install"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.1.0",
        "@angular/cdk": "^19.1.2",
        "@angular/common": "^19.1.4",
        "@angular/compiler": "^19.1.0",
        "@angular/core": "^19.1.0",
        "@angular/forms": "^19.1.0",
        "@angular/material": "^19.1.2",
        "@angular/platform-browser": "^19.1.0",
        "@angular/platform-browser-dynamic": "^19.1.0",
        "@angular/router": "^19.1.0",
        "@ngx-translate/core": "^16.0.4",
        "capacitor-screenshot": "^7.3.0",
        "html-to-image": "^1.11.13",
        "html2canvas": "^1.4.1",
        "js-sha1": "^0.7.0",
        "jsonrepair": "^3.13.1",
        "jspdf": "^3.0.4",
        "marked": "^15.0.8",
        "modern-screenshot": "^4.6.7",
        "ngx-capture": "^0.14.0",
        "ngx-cookie-service": "^19.1.0",
        "ngx-image-cropper": "^9.1.2",
        "ngx-markdown": "^19.1.1",
        "rxjs": "~7.8.0",
        "translate": "^3.0.1",
        "tslib": "^2.3.0",
        "uuid": "^11.1.0",
        "w-html2png": "^1.0.30",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.1.0",
        "@angular/cli": "^19.1.0",
        "@angular/compiler-cli": "^19.1.0",
        "@angular/localize": "^19.1.4",
        "@semantic-release/commit-analyzer": "^13.0.1",
        "@semantic-release/git": "^10.0.1",
        "@semantic-release/gitlab": "^13.3.3",
        "@semantic-release/npm": "^13.2.0",
        "@semantic-release/release-notes-generator": "^14.1.1",
        "@types/jasmine": "~5.1.0",
        "@types/node": "^24.10.1",
        "conventional-changelog-conventionalcommits": "^9.3.1",
        "husky": "^8.0.0",
        "jasmine-core": "~5.5.0",
        "karma": "~6.4.0",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "semantic-release": "^25.0.9",
        "stylelint": "17.0.0",
        "stylelint-config-standard-scss": "17.0.0",
        "typescript": "~5.7.2"
    }
}
